import React, {useCallback} from 'react';
import cx from 'classnames';
import {Title, Flex, Button} from '@priority-software/priority-style-react';
import usePortal from 'react-useportal';
import styles from './styles.module.scss';
import {apiLocker, formsStore} from '../../../../stores/Form';

type Props = {
    locked?: boolean;
    showLoader?: boolean;
    toggleLoader?: (flag: boolean) => void;
    zIndex?: number;
    canCancel?: boolean;
};

export const ScreenLocker = ({
    locked,
    showLoader,
    toggleLoader,
    zIndex = 14000,
    canCancel = true
}: Props) => {
    const form = formsStore.currentForm;
    const cancelLoader = useCallback(() => {
        toggleLoader?.(false);
        form.onCancelRs();
        if (formsStore.currentSession) {
            const lockData = apiLocker.getDataBySession(formsStore.currentSession);
            lockData?.unlockAPI();
        }
    }, [toggleLoader, form]);
    const {Portal} = usePortal();

    return (
        <Portal>
            {locked && (
                <div
                    style={{zIndex}}
                    className={cx(styles.screenLocker, 'ignore-react-onclickoutside')}
                />
            )}

            {showLoader && (
                <div className={styles.loaderWrap} style={{zIndex: zIndex + 1}}>
                    <Title
                        textColor="primary-500"
                        text="Priority"
                        skin="h3"
                        componentClasses={styles.loaderTitle}
                    />

                    <div className={styles.loader}>
                        <div className={styles.loaderBar} />
                    </div>

                    {canCancel && (
                        <Flex justifyContent="flex-end" componentClasses={styles.loaderFooter}>
                            <Button skin="primary" onClick={cancelLoader} size="medium">
                                Cancel
                            </Button>
                        </Flex>
                    )}
                </div>
            )}
        </Portal>
    );
};
